<template>
  <section class="tienda-descargas" :style="{ backgroundImage: 'url(' + fondo_aciqui + ')' }">
    <div class="overlay"></div>

    <div class="content">
      <!-- Logo -->
      <img :src="icon_aciqui" alt="Logo ACIQUI" class="logo" />

      <!-- Título -->
      <h1>{{ title }}</h1>

      <!-- Descripción -->
      <p class="subtitle">
        Descarga la aplicación oficial y accede a todos los servicios desde tu dispositivo móvil.
      </p>

      <!-- Botones -->
      <v-row justify="center" class="mt-4">
        <!-- Android -->
        <v-col cols="12" sm="12">
          <v-btn v-if="isAndroid" color="green darken-2" dark large class="mr-4" :href="URL_ANDROID">
            Descargar para Android
          </v-btn>
        </v-col>


        <!-- iOS -->
        <v-col cols="12" sm="12">
          <v-btn v-if="isiOS" color="blue darken-2" dark large @click="instalariOS">
            Descargar para iOS
          </v-btn>
        </v-col>

      </v-row>
    </div>
  </section>
</template>

<script>
import icon_aciqui from '@/assets/images/logo_store.svg';
import fondo_aciqui from '@/assets/images/background_phones.svg';

import androidMovil from './src/img/androidwhitemovil.svg';
import iosMovil from './src/img/iosmovil.svg'

import TiendaAciquiDataService from "../../../services/TiendaAciquiDataService";

import { destruirAlerta } from "../../../utils/Utils"

export default {
  name: "TiendaDescargas",
  data() {
    return {
      icon_aciqui,
      fondo_aciqui,
      androidMovil,
      iosMovil,
      title: "Descarga la app ACIQUI",
      isAndroid: false,
      isiOS: false,
      URL_ANDROID: `${process.env.VUE_APP_SERVIDOR_TIENDA}/asincrona/tiendaAciqui/androidapk`,
      URL_IOS: `itms-services://?action=download-manifest&url=${process.env.VUE_APP_SERVIDOR_TIENDA}/asincrona/tiendaAciqui/plist`
    };
  },
  mounted() {
    

    // Cuando se cierra la pestaña, quitarlo
    window.addEventListener("beforeunload", () => {
      localStorage.removeItem("esCompartirLink");

    });

    destruirAlerta();

    this.detectPlatform();
  },
  created() {
    

  },
  methods: {
    
    async detectPlatform() {
      // Accedemos al userAgent de forma segura
      const userAgent = navigator.userAgent || navigator.vendor || globalThis.opera;

      if (/android/i.test(userAgent)) {
        this.isAndroid = true;
      } else if (/iPhone/i.test(userAgent) && !globalThis.MSStream) {
        this.isiOS = true;
      } else {
        this.title = "Acceda desde su smartphone Android o iOS para descargar la app";
      }
    },

    async descargarAndroidAPK() {
      try {
        const response = await TiendaAciquiDataService.getAndroid();
        const url = globalThis.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', 'aciqui.apk'); // nombre del APK
        document.body.appendChild(link);
        link.click();
        link.remove();
        globalThis.URL.revokeObjectURL(url);
      } catch (error) {
        console.error('Error descargando APK:', error);
      }
    },

    instalariOS() {
      // Redirige al esquema itms-services:// para que iOS instale desde plist
      globalThis.location.href = this.URL_IOS;
    }



  },//End methods
};
</script>

<style scoped lang="scss">
.tienda-descargas {
  position: relative;
  height: 100vh;
  width: 100%;

  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  color: white;
  font-family: "Inter", sans-serif;

  /* Fondo de respaldo con gradientes */
  background: radial-gradient(circle at 75% -50%, #00000090 30%, #ffffff00 40%),
    linear-gradient(-40deg, #ff000000, #080c34 60%, #0000ff00),
    radial-gradient(circle at 55% 150%, #3094bc 40%, #00000010 70%),
    radial-gradient(at 0% 0%, #206ca4 5%, #00000000 40%),
    linear-gradient(to bottom, #080c34 0%, #184c7c 100%);

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
}

.overlay {
  position: absolute;
  inset: 0;
  background: rgba(0, 0, 0, 0.45);
  backdrop-filter: blur(6px);
}

.content {
  position: relative;
  z-index: 2;
  text-align: center;
  max-width: 500px;
  background: rgba(255, 255, 255, 0.05);
  border-radius: 20px;
  padding: 3rem 2rem;
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.4);
  backdrop-filter: blur(8px);
}

.logo {
  width: 140px;
  margin-bottom: 1.5rem;
  filter: drop-shadow(0 2px 8px rgba(255, 255, 255, 0.4));
}

h1 {
  font-size: 1.8rem;
  margin-bottom: 1rem;
  font-weight: 700;
  color: white;
}

.subtitle {
  font-size: 1rem;
  color: #e0e0e0;
  margin-bottom: 2rem;
}

.buttons {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  align-items: center;
}

.btn {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 10px;
  text-decoration: none;
  font-weight: 600;
  padding: 0.9rem 1.8rem;
  border-radius: 999px;
  transition: all 0.3s ease;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.25);
  width: 80%;
  max-width: 300px;
}

.btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 8px 20px rgba(0, 0, 0, 0.35);
}

.android-btn {
  background-color: #078d44;
  color: #000;
  font-weight: bold;
}

.ios-btn {
  background-color: #000;
  color: #fff;
}

.icon {
  width: 22px;
  height: 22px;
}

.note {
  color: #ddd;
  margin-top: 1rem;
  font-size: 0.9rem;
}

/* 📱 Responsivo */
@media (max-width: 600px) {
  .content {
    width: 90%;
    padding: 2rem 1.5rem;
  }

  h1 {
    font-size: 1.5rem;
  }

  .subtitle {
    font-size: 0.9rem;
  }

  .btn {
    width: 100%;
  }
}
</style>
